import { combineReducers } from "redux";
import clients from "./clients";
import finance from "./finance";
import savedLocations from "./saved-locations";
import driverAppSettings from "./driver-app-settings";
import routeWithStops from "./route-with-stops";
import undispatchedCargos from "./undispatched-cargos";
import notebooks from "./notebooks";
import stopsDocuments from "./stops-documents";

export default combineReducers({
  clients,
  finance,
  driverAppSettings,
  savedLocations,
  routeWithStops,
  undispatchedCargos,
  notebooks,
  stopsDocuments,
});
